import { all, fork } from "redux-saga/effects";
import { watchBookingSaga } from "./bookingSaga";
import { watchAuthSaga } from "./authSaga";
import { watchShowSaga } from "./showSaga";
import { watchSeatSaga } from "./seatSaga";
import { watchSettingSaga } from "./settingSaga";
import { watchTheaterSaga } from "./theaterSaga";
import { watchUserSaga } from "./userSaga";
import { watchPublicSaga } from "./public.saga";
import { watchLogSaga } from './logSaga';
import { watchErrorLogSaga } from './errorLogSaga';
import { watchBackupSaga } from './backupSaga';
import { watchPromoCodeSaga } from './promocodeSaga';

const rootSaga = function* () {
  yield all([
    fork(watchAuthSaga),
    fork(watchBookingSaga),
    fork(watchShowSaga),
    fork(watchSeatSaga),
    fork(watchSettingSaga),
    fork(watchTheaterSaga),
    fork(watchUserSaga),
    fork(watchPublicSaga),
    watchLogSaga(),
    watchErrorLogSaga(),
    fork(watchBackupSaga),
    fork(watchPromoCodeSaga)
  ]);
};

export default rootSaga;